import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { ConfigurationField } from './configuration-field';

@inheritSerialization(AbstractModel)
export class ConfigurationValue extends AbstractModel {
  @autoserializeAs(ConfigurationField)
  configurationField: ConfigurationField;

  @autoserialize
  value: string;

  @autoserialize
  objectType: string;

  @autoserialize
  objectId: number | null;

  @autoserialize
  createdByUserId: number | null;

  @autoserialize
  active: boolean;
}
